import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import img from "../assets/profile.png";
import verifed from "../assets/gold-verified-1.png"
import star from "../assets/Star_icon.png"

const BrowseTasks = () => {
  const [activeTask, setActiveTask] = useState('all');
  const [searchTerm, setSearchTerm] = useState('');

  const tasks = [
    { id: 'all', name: 'All Services', description: '', type: 'all' },
    { id: 'plumber', name: 'Plumbing', description: 'Pipe, leakage, fittings', type: 'plumber' },
    { id: 'electrician', name: 'Electrician', description: 'Wiring, fan, lights', type: 'electrician' },
    { id: 'carpenter', name: 'Carpentry', description: 'Furniture, repair', type: 'carpenter' }
  ];

  const technicians = [
    {
      id: 1,
      name: 'Rahul Sharma',
      skill: 'Plumber',
      experience: '5 yrs exp',
      rating: 4.8,
      reviews: 120,
      verified: true,
      type: 'plumber',
      image: img
    },
    {
      id: 2,
      name: 'Amit Das',
      skill: 'Electrician',
      experience: '3 yrs',
      rating: 4.8,
      reviews: 120,
      verified: true,
      type: 'electrician',
      image: img
    },
    {
      id: 3,
      name: 'Suresh Kumar',
      skill: 'Carpenter',
      experience: '7 yrs exp',
      rating: 4.9,
      reviews: 245,
      verified: true,
      type: 'carpenter',
      image: img
    },
    {
      id: 4,
      name: 'Vikram Singh',
      skill: 'Plumber',
      experience: '4 yrs exp',
      rating: 4.7,
      reviews: 98,
      verified: true,
      type: 'plumber',
      image: img
    },
    {
      id: 5,
      name: 'Rajesh Patel',
      skill: 'Electrician',
      experience: '6 yrs exp',
      rating: 4.9,
      reviews: 310,
      verified: true,
      type: 'electrician',
      image: img
    }
  ];

  const filteredTechnicians = technicians.filter(tech => {
    const matchesType = activeTask === 'all' || tech.type === activeTask;
    const matchesSearch = tech.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
                         tech.skill.toLowerCase().includes(searchTerm.toLowerCase());
    return matchesType && matchesSearch;
  });

  return (
    <main>
      <section className="browse-page">
        {/* SEARCH BAR */}
        <div className="browse-search">
          <input
            type="text"
            id="searchInput"
            placeholder="Search technicians or services..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </div>

        {/* MAIN LAYOUT */}
        <div className="browse-container">
          {/* LEFT: TASKS */}
          <div className="tasks-panel">
            <h3 className="filter-title">Tasks</h3>
            
            {tasks.map((task) => (
              <div 
                key={task.id}
                className={`task-card ${activeTask === task.type ? 'active' : ''}`}
                data-type={task.type}
                onClick={() => setActiveTask(task.type)}
              >
                <h4>{task.name}</h4>
                {task.description && <p>{task.description}</p>}
              </div>
            ))}
          </div>

          {/* RIGHT: TECHNICIANS */}
          <div className="tech-panel">
            {filteredTechnicians.length > 0 ? (
              filteredTechnicians.map((tech) => (
                <Link to="/tech-profile" key={tech.id} className="b-tech-card-link">
                  <div className="b-tech-card" data-type={tech.type}>
                    <img src={tech.image} alt={tech.name} />
                    <div className="info">
                      <h4 className="tech-name">{tech.name}</h4>
                      <p className="tech-skill">{tech.skill} • {tech.experience}</p>
                      <div className="v-r-cont">
                        {tech.verified && (
                          <span className="verified" id="verified">
                            <img src={verifed} alt="verified tradie" />
                            Verified Tradie
                          </span>
                        )}
                        <p className="rating rating-center" id="star-rating">
                          <img src={star} alt="" /> {tech.rating} ({tech.reviews} reviews)
                        </p>
                      </div>
                    </div>
                    <button className="call-btn">Call</button>
                  </div>
                </Link>
              ))
            ) : (
              <div className="no-results">
                <p>No technicians found matching your criteria.</p>
              </div>
            )}
          </div>
        </div>
      </section>
    </main>
  );
};

export default BrowseTasks;